<template>
    <html>
    <body style="position: relative;background: #fff" v-loading="loading">
        <!--主体开始-->
        <div class="nding">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/agricultural/index">农技服务</a>&gt; <a href="">农技课程</a>
            </div>
        </div>
        <div class="fenlei">
            <ul class="sh">
                <li v-for="item in typelist" :key="item.tid"><a :class="item.tid == parentTid ? 'on' : ''" href="javascript:void(0)" @click="getChild(item.id)">{{item.typename}}</a></li>
            </ul>
            <div class="xia1">
                <ul>
                    <h4>{{typename}}</h4>
                    <div>
                        <li v-for="item in childtypelist" :key="item.tid"><a :class="item.tid == tid ? 'on' : ''" :href="'/agricultural/courselist?tid='+item.tid">{{item.typename}}</a></li>
                    </div>
                </ul>
            </div>
        </div>
        <section class="section ncontainer1">
            <div class="neit">
                <div class="videoBox clearfix">
                    <ul class="content_new">
                        <a :href="'/agricultural/coursedetails?id='+item.id" t="0" v-for="item in coursePage" :key="item.id">
                            <li class="video_item">
                                <div class="c_img">
                                    <img :src="$util.img(item.image)" class="lazy" data-original="" alt=" " />
                                    <div class="overlay"> <i class="iconfont icon-shipin"></i> </div>
                                </div>
                                <div class="c_info">
                                    <h6> <span class="caption">{{item.name}}</span> </h6>
                                    <p>{{ $util.timeStampTurnTime(item.createtime, 'YYYY-MM-DD') }}</p>
                                </div>
                            </li>
                        </a>
                    </ul>
                </div>
            </div>
            <div class="pages">
                <div class="Pagination"></div>
                <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
            </div>
        </section>

    </body>
</html>
</template>

<script>
    import '@/assets/styles/js/jquery.pagination.js';
    import { publictypeList } from '@/api/publicType/publicType';
    import { coursePage } from '@/api/course/course';

    export default {
        name: '',
        components: {},
        data: () => {
            return {
                loading: true,
                coursePage:[],
                pageCount:0,
                page_size:10,
                page:1,
                typelist:[],
                childtypelist:[],
                typename:'',
                tid:'',
                parentTid:''
            };
        },
        created() {
            this.tid = this.$route.query.tid;
            this.getcoursePage();
            this.gettypelist();
        },

        methods: {
            getcoursePage() {
                coursePage({
                    page_size: this.page_size,
                    page: this.page,
                    tid: this.tid
                }).then(res => {
                    if(res.code == 0) {
                        this.pageCount = res.data.page_count;
                        $(".Pagination").pagination(this.pageCount, {
                            callback: this.changepage
                        });
                        $(".allPage").text(this.pageCount);
                        this.coursePage = res.data.list;
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    //this.$message.error(err.message);
                });
            },
            gettypelist() {
                publictypeList({
                    typenumber: "10005",
                    level: 2
                }).then(res => {
                    if(res.code == 0) {
                        this.typelist = res.data;
                        if(this.typelist.length > 0) {
                            var pid = this.typelist[0].tid;
                            this.typename = this.typelist[0].typename;
                            this.getChild(pid);
                        }
                    }
                })
            },
            changepage(page_id) {
                this.loading = true;
                this.page = page_id + 1;
                coursePage({
                    page_size: this.page_size,
                    page: this.page,
                    tid: this.tid
                }).then(res => {
                    if(res.code == 0) {
                    this.coursePage = res.data.list;
                    this.loading = false;
                    }
                });
            },
            getChild(pid) {
                this.parentTid = pid;
                publictypeList({
                    typenumber: "10005",
                    parent_id: pid,
                }).then(res => {
                    if(res.code == 0) {
                        this.childtypelist = res.data;
                    }
                });
            }
        }

    }
</script>
